module.exports = __webpack_public_path__ + "static/media/gallery03.8d1df78b.png";